import { render } from "./DocDetail.vue?vue&type=template&id=60fa490c&scoped=true"
import script from "./DocDetail.vue?vue&type=script&lang=js"
export * from "./DocDetail.vue?vue&type=script&lang=js"

import "./DocDetail.vue?vue&type=style&index=0&id=60fa490c&lang=css"
import "./DocDetail.vue?vue&type=style&index=1&id=60fa490c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fa490c"]])

export default __exports__